import { render, staticRenderFns } from "./LoyaltyCard.vue?vue&type=template&id=55136333&lang=pug&"
import script from "./LoyaltyCard.vue?vue&type=script&lang=js&"
export * from "./LoyaltyCard.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports